import {
	FeatureFlag,
	getFeatureFlags,
	getFeatureSupportedLanguages,
	isFeatureEnabled,
} from '@/app/config/feature-flags'

/**
 * Hook for accessing feature flags in React components.
 *
 * This is for environment-based feature toggling (dev/int/acpt/prod).
 * Supports optional language restrictions per feature.
 * For A/B testing experiments, use GrowthBook's useFeatureIsOn instead.
 *
 * @example
 * ```tsx
 * const { isEnabled } = useFeatureFlags()
 *
 * // Check if feature is enabled (environment only)
 * if (isEnabled(FeatureFlag.BLOG)) {
 *   return <BlogLink />
 * }
 *
 * // Check if feature is enabled for a specific locale
 * if (isEnabled(FeatureFlag.BLOG, 'en')) {
 *   return <BlogLink />
 * }
 * ```
 */
export const useFeatureFlags = () => {
	return {
		isEnabled: isFeatureEnabled,
		getAllFlags: getFeatureFlags,
		getSupportedLanguages: getFeatureSupportedLanguages,
	}
}

export { FeatureFlag }

